type FileFormatCategory =
  | "documents"
  | "images"
  | "videos"
  | "spreadsheets"
  | "presentations"
  | "other"

const FILE_FORMAT_CATEGORIES: FileFormatCategory[] = [
  "documents",
  "images",
  "videos",
  "spreadsheets",
  "presentations",
  "other"
]

// Extension wins over mime type: a `ProjectDocument` carries a filename but no
// mime type at all, so classifying by extension is the only thing that works
// for both file sources — an Attachment's mime type is only a fallback for a
// file with no recognisable extension.
const EXTENSION_CATEGORIES: Record<string, FileFormatCategory> = {
  pdf: "documents",
  doc: "documents",
  docx: "documents",
  txt: "documents",
  rtf: "documents",
  odt: "documents",
  jpg: "images",
  jpeg: "images",
  png: "images",
  gif: "images",
  heic: "images",
  webp: "images",
  svg: "images",
  bmp: "images",
  tiff: "images",
  mp4: "videos",
  mov: "videos",
  avi: "videos",
  webm: "videos",
  mkv: "videos",
  m4v: "videos",
  xls: "spreadsheets",
  xlsx: "spreadsheets",
  csv: "spreadsheets",
  ods: "spreadsheets",
  ppt: "presentations",
  pptx: "presentations",
  key: "presentations"
}

const classifyFileFormat = (file: {
  name: string
  mimeType?: string | null
}): FileFormatCategory => {
  const extension = file.name.split(".").pop()?.toLowerCase()
  if (extension && extension in EXTENSION_CATEGORIES) {
    return EXTENSION_CATEGORIES[extension]
  }
  if (file.mimeType?.startsWith("image/")) return "images"
  if (file.mimeType?.startsWith("video/")) return "videos"
  if (file.mimeType === "application/pdf") return "documents"
  return "other"
}

export { classifyFileFormat, FILE_FORMAT_CATEGORIES }
export type { FileFormatCategory }
